<template lang="pug">
modal(v-if="agenda")
	.card.text-left
		.card-header.bg-info.text-white
			span.fa.fa-list.mr-2
			| Listado noticias de: {{agenda.Titulo}}
			button.close(@click="cerrar") &times;
		table.table.table-striped.m-0
			thead
				tr
					th Usuario
					th Fecha
					th Titular
					th
			tbody
				tr(
					v-for="noticia in listado"
					:key="noticia.NoticiaID"
				)
					td {{noticia.AutorNombre}}
					td {{noticia.FechaModificacionUnix | moment('DD-MM-YYYY')}}
					td {{noticia.Titular}}
					td
						a.btn.btn-sm.btn-primary(:href="'/#/main/redaccion/editor/' + noticia.NoticiaID", target="_blank")
							span.fa.fa-eye
</template>


<script>
export default {
	props: ['agenda'],
	created () {
		this.getNoticias()
	},
	data () {
		return {
			listado: []
		}
	},
	methods: {
		getNoticias () {
			this.$http.post('redaccion/php/api/agenda/listadoNoticias.php', {AgendaID: this.agenda.AgendaID})
				.then(res => {
					this.listado = res.data
				})
				.catch(e => {
					this.$error('Error', e.response.data.error)
				})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/agenda/listadoNoticias.vue